// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import Select, { components } from 'react-select';

class State {
  name = '';
}
export default class SimpleSelect extends React.Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { name } = this.props;
    this.setState({ name });
  }

  optionWithIcon = props => {
    const marginRight = props.data.icon !== 'fas fa-walking' ? '10px' : '15px';
    return (
      <components.Option {...props}>
        {props.data.icon && (
          <i className={props.data.icon} style={{ marginRight }} />
        )}
        {props.data.label}
      </components.Option>
    );
  };

  valueWithIcon = props => {
    const marginRight = props.data.icon !== 'fas fa-walking' ? '10px' : '15px';
    return (
      <components.SingleValue {...props}>
        {props.data.icon && (
          <i className={props.data.icon} style={{ marginRight }} />
        )}
        {props.data.label}
      </components.SingleValue>
    );
  };

  onChange = (val, act) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { onChange } = this.props;
    const { name } = this.state;
    switch (act.action) {
      case 'select-option': {
        onChange(val.value, name);
        break;
      }
      default: {
        break;
      }
    }
  };

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      placeholder,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      disabled,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      style,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      value,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      data,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      targetBody = true,
    } = this.props;
    let currentVaLue = null;
    if (value) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      currentVaLue = data.find(elem => elem.value === value);
    }
    return (
      <div style={{ position: 'relative', ...style }}>
        <Select
          classNamePrefix={'simple-select'}
          menuContainerStyle={{ zIndex: 999 }}
          menuPortalTarget={targetBody ? document.body : undefined}
          placeholder={placeholder}
          components={{
            Option: this.optionWithIcon,
            SingleValue: this.valueWithIcon,
            DropdownIndicator: () => (
              <Glyphicon
                style={{ color: '#c4c4c4', paddingRight: '10px' }}
                glyph='chevron-down'
              />
            ),
            IndicatorSeparator: () => null,
            ClearIndicator: () => null,
          }}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 9999 }),
            menu: styles => ({ ...styles, zIndex: 9999 }),
            control: styles => ({
              ...styles,
              '&:focus': {
                borderColor: '#4496d8',
                boxShadow: 'none',
                outline: '0',
              },
            }),
          }}
          openMenuOnClick
          isDisabled={disabled}
          value={currentVaLue}
          isSearchable={false}
          onChange={this.onChange}
          options={data}
        />
      </div>
    );
  }
}
